import React, { useContext, useEffect, useState } from "react";
import { FaviconMetaTag } from "./FaviconMetaTag";
import { LocaleContext } from "../../contexts/LocaleContext";
import styled from "styled-components";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { useScrollPosition } from "../../hooks/useScrollPosition";
import { mediaQuery } from "../../theme/constants";
import GlobalStyle from "../../theme/global";
import { ChangeCta } from "../ChangeCta";
// @ts-ignore-next-line
import { HelmetDatoCms } from "gatsby-source-datocms";
import { graphql, useStaticQuery } from "gatsby";
import { ContactCtaSection } from "../Ctas/ContactCta";

interface DefaultLayoutProps {
  compactFooter?: boolean;
  hideCta?: boolean;
  className?: string;
  customCta?: React.ReactNode;
  seo?: any;
  slug?: string;
  notificationPopup?: React.ReactNode;
  hideMenu?: boolean;
  embedded?: boolean;
}

const Seo = ({ seo }: { seo?: any }) => {
  const query = useStaticQuery(graphql`
    query {
      global: datoCmsGlobal {
        seoMetaTags {
          tags
        }
      }
    }
  `);
  return <HelmetDatoCms seo={seo ? seo : query.global.seoMetaTags} />;
};

export const DefaultLayout = (
  props: React.PropsWithChildren<DefaultLayoutProps>
) => {
  const { locale } = useContext(LocaleContext);
  const [flatMenu, setFlatMenu] = useState(false);
  const scrollPosition = useScrollPosition();

  useEffect(() => {
    if (scrollPosition > 120 && !flatMenu) {
      setFlatMenu(true);
    }
    if (scrollPosition <= 120 - 36 && flatMenu) {
      setFlatMenu(false);
    }
  }, [scrollPosition, flatMenu]);

  const showMenu = props.hideMenu === undefined ? true : !props.hideMenu;

  const cta = props.customCta ?? <ContactCtaSection />;

  return (
    <>
      {props.notificationPopup}
      <Container className={props.className} embedded={props.embedded}>
        <GlobalStyle />
        <FaviconMetaTag locale={locale} />
        <Seo seo={props.seo} />
        {showMenu && (
          <>
            <Navbar flatMenu={flatMenu} slug={props.slug} />
            <Spacer height={flatMenu ? 69 : 100} />
          </>
        )}
        <Main embedded={props.embedded}>
          <>{props.children}</>

          <>{!props.hideCta && cta}</>
        </Main>
        {showMenu && <Footer compact={props.compactFooter} />}
      </Container>
    </>
  );
};

const Container = styled.div<{ embedded?: boolean }>`
  display: flex;
  flex-direction: column;
  min-height: ${(props) => (!props.embedded ? "100vh" : "auto")};
`;

const Main = styled.main<{ embedded?: boolean }>`
  flex-grow: ${(props) => (props.embedded ? 0 : 1)};
  display: flex;
  flex-direction: column;
`;

const Spacer = styled.div<{ height: number }>`
  height: ${({ height }) => height}px;
  ${mediaQuery.medium} {
    height: 64px;
  }
  transition: all 0.3s;
  width: 100%;
`;
